module.exports = __webpack_public_path__ + "media/images/logos/c-map-b14c10c03fe1354f05eb34440482b8fb.png";